import { AuthOptions } from './AuthOptions';

export default function SignupPage() {
  return (
    <div className="flex min-h-[calc(100vh-64px)] flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-md rounded-lg border bg-card p-8 shadow-sm">
        <AuthOptions 
          mode="signup" 
          showLoginLink={true}
          showTermsFooter={true}
        />
      </div>
    </div>
  );
} 